function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "2/8u";


//////////////////
// WEBPACK FOOTER
// ./redevelopment/input/drawback ^\.\/.*$
// module id = 2/8u
// module chunks = 0